import React, { useState, useEffect, useContext } from 'react';
import { createSupplier, updateSupplier, getCategory } from '../../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../../Utility/UserContext';

const SupplierForm = ({ selectedSupplier, onClose, fetchSuppliers }) => {
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);

  const [formData, setFormData] = useState({
    full_name: '',
    address1: '',
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
    address2: '',
    address3: '',
    email: '',
    phone: '',
    postal_code: '',
    VAT_no: '',
    remarks: ''
  });

  const [BankData, setBankData] = useState({
    supplier_id: '',
    account_name: '',
    account_no: '',
    bank: '',
    branch: '',
    ifsc_swift_code: '',
  });

  const [categories, setCategories] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchCategories();
    if (selectedSupplier) {
      setFormData({
        full_name: selectedSupplier?.full_name || '',
        address1: selectedSupplier?.address1 || '',
        address2: selectedSupplier?.address2 || '',
        address3: selectedSupplier?.address3 || '',
        email: selectedSupplier?.email || '',
        phone: selectedSupplier?.phone || '',
        postal_code: selectedSupplier?.postal_code || '',
        VAT_no: selectedSupplier?.VAT_no || '',
        remarks: selectedSupplier?.remarks || '',
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
      });
      setBankData({
        supplier_id: selectedSupplier?.supplier_id || '',
        account_name: selectedSupplier?.account_name || '',
        account_no: selectedSupplier?.account_no || '',
        bank: selectedSupplier?.bank || '',
        branch: selectedSupplier?.branch || '',
        ifsc_swift_code: selectedSupplier?.ifsc_swift_code || '',
      });
    }
  }, [selectedSupplier]);

  const fetchCategories = async () => {
    try {
      const response = await getCategory();
      if (response.data && response.data.data) {
        setCategories(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Error fetching categories');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,

      });
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      return;
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    setBankData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    showLoader();

    const validationErrors = {};

    // Validate required fields
    for (const key in formData) {
      if (["full_name", "phone", "address1"].includes(key)) {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
        }
      }
    }

    // Validate phone number length (min 8 digits)
    if (formData.phone && formData.phone.length < 8) {
      validationErrors.phone = "Phone number must be at least 8 digits long.";
    }

    // If errors exist, set errors and stop execution
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      console.log("Validation Errors:", validationErrors);
      return;
    }

    const payload = {
      supplier: formData,
      bank: BankData,
    };

    try {
      if (selectedSupplier) {
        await updateSupplier(selectedSupplier.supplier_id, payload);
        toast.success("Supplier updated successfully");
      } else {
        await createSupplier(payload);
        toast.success("Supplier added successfully");
      }
      onClose();
      fetchSuppliers();
    } catch (error) {
      console.error("Error saving supplier data:", error.response?.data?.message);
      toast.error(error.response?.data?.errors?.email?.[0] || "An error occurred");
    } finally {
      hideLoader();
    }
  };


  const InputField = (label, name, type, value, onChange, placeholder, colSize, required, error) => (
    <div className={`col-${colSize}`}>
      <label>{label}</label>
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="form-control"
      />
      {error && <small className="text-danger">{error}</small>}
    </div>
  );

  const TextArea = (label, name, type, value, onChange, placeholder, colSize, required) => (
    <div className={`col-${colSize}`}>
      <label>{label}</label>
      <textarea
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className="form-control"
      />
    </div>
  );

  const feilds = (
    <div className='row d-flex'>
      <div className="col-12 col-md-6 ">
        {InputField("Suppliers", "full_name", "text", formData.full_name, handleChange, "Enter Name", 12, null, errors.full_name)}
        {InputField("Address 1", "address1", "text", formData.address1, handleChange, "Enter Address 1", 12, errors.address1)}
        {InputField("Address 2", "address2", "text", formData.address2, handleChange, "Enter Address 2", 12, errors.address2)}
        {InputField("Address 3", "address3", "text", formData.address3, handleChange, "Enter Address 3", 12, errors.address3)}
        {InputField("Email", "email", "text", formData.email, handleChange, "Enter Email", 12, null, errors.email)}
        <div className="d-flex column-gap-1 d-none">
          {InputField("Balance", "opening_balance", "text", formData.opening_balance, handleChange, "Enter Balance", 8, null, errors.opening_balance)}
          <div className="col-4">
            <select
              name="CR_DR"
              value={formData.CR_DR}
              onChange={handleChange}
              className="form-control"
              style={{ height: "1.5rem", margin: "1px", fontSize: "0.7rem" }}
            >
              <option value="">Select CR DR</option>
              <option key="0" value="0">CR</option>
              <option key="1" value="1">DR</option>
            </select>
          </div>
        </div>
        {TextArea("Remarks", "remarks", "text", formData.remarks, handleChange, "Enter your remark", 12, null)}
      </div>
      <div className="col-12 col-md-6">
        {InputField("Phone", "phone", "text", formData.phone, handleChange, "Enter Phone Number", 12, null, errors.phone)}
        {InputField("VAT No", "VAT_no", "text", formData.VAT_no, handleChange, "Enter VAT", 12, null, errors.VAT_no)}
        {InputField("Postal Code", "postal_code", "text", formData.postal_code, handleChange, "Enter Postal code", 12, null, errors.postal_code)}
        {InputField("Account Name", "account_name", "text", BankData.account_name, handleBankChange, "Enter Account Name", 12, null, errors.account_name)}
        {InputField("Account no", "account_no", "text", BankData.account_no, handleBankChange, "Enter Account No", 12, null, errors.account_no)}
        {InputField("Bank", "bank", "text", BankData.bank, handleBankChange, "Enter Bank", 12, null, errors.bank)}
        {InputField("Branch", "branch", "text", BankData.branch, handleBankChange, "Enter Branch", 12, null, errors.branch)}
        {InputField("Bank code", "ifsc_swift_code", "text", BankData.ifsc_swift_code, handleBankChange, "Enter Bank Code", 12, null, errors.ifsc_swift_code)}
      </div>
    </div>
  );

  return (
    <div className="modal fade show modal-lg" style={{ display: 'block' }} tabIndex="-1" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" style={{ fontFamily: "poppins" }}>{selectedSupplier ? 'Edit Supplier' : 'Add Supplier'}</h5>
            <button type="button" className="btn-close" aria-label="Close" onClick={onClose}></button>
          </div>
          <div className="modal-body" style={{ fontFamily: "poppins" }}>
            <form onSubmit={handleSubmit}>
              {feilds}
              <div className="d-flex justify-content-end mt-2" style={{ gap: "12px" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  style={{ fontFamily: "poppins" }}
                  onClick={onClose}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-success">
                  {selectedSupplier ? 'Update Supplier' : 'Add Supplier'}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierForm;